import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-time',
  templateUrl: './confirm-time.component.html',
  styleUrls: ['./confirm-time.component.scss']
})
export class ConfirmTimeComponent implements OnInit {
countdown: number = 60;  // Countdown time in seconds
  intervalId: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmTimeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {}

  ngOnInit(): void {
    this.startCountdown();
  }

  // Start the countdown timer
  startCountdown() {
    this.intervalId = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.closeModal(false);
      }
    }, 1000);
  }

  // Close the modal (you can customize this to emit events or use Angular Material dialogs)
  closeModal(relogin) {
    clearInterval(this.intervalId);
    this.dialogRef.close(relogin)
    // You can add your modal close logic here, e.g., emit an event or close a dialog
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);  // Clear interval on destroy to avoid memory leaks
  }
}